// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_Text.scss
// module id = 677
// module chunks = 60 88